import information from './mainFrom/information.vue';
import notification from './mainFrom/notification.vue';
import rendering from './mainFrom/rendering.vue';
import planList from './mainFrom/planList.vue';
import { mainDetailV2 } from './request';
export default {
  components: {
    information,
    rendering,
    planList,
    notification
  },
  data() {
    return {
      active: -1,
      id: this.$route.params.id,
      infoObj: {}
    };
  },
  created() {
    this.getInfoFun();
  },
  methods: {
    getInfoFun() {
      if (this.id != -1) {
        mainDetailV2({
          insuranceId: this.id
        }).then(res => {
          console.log(res);
          this.infoObj = res;
          if (this.active == -1) {
            this.active = 0;
          }
        });
      } else {
        this.active = 0;
      }
    },
    nextFun(val) {
      if (val) {
        this.id = val.insuranceId;
        this.getInfoFun();
      }
      this.active = this.active + 1;
    },
    prevFun() {
      this.active = this.active - 1;
    },
    nextFun2(num) {
      if (this.$route.params.id != -1) {
        this.active = num;
      }
    }
  }
};